import React from 'react';

function Terms() {
  return (
    <div className="container" style={{ maxWidth: 800, paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header">
        <h1 className="page-title">用户协议</h1>
        <p className="page-subtitle">最后更新日期：2026年4月10日</p>
      </div>

      <div className="card" style={{ lineHeight: 1.9, fontSize: '0.92rem', color: 'var(--text-secondary)' }}>
        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>一、总则</h3>
        <p style={{ marginBottom: 16 }}>
          欢迎使用 RollSleeves.com（以下简称"本平台"）。本平台由 RollSleeves 团队运营和管理，致力于为中国背景候选人提供涉外岗位信息发布与交流服务。请您在使用本平台前仔细阅读本用户协议（以下简称"本协议"）。注册或使用本平台即表示您同意受本协议约束。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>二、账户注册与使用</h3>
        <p style={{ marginBottom: 16 }}>
          1. 您需要提供真实、准确、完整的注册信息，并在信息变更时及时更新。<br />
          2. 您应妥善保管账户密码，因账户密码保管不善导致的损失由您自行承担。<br />
          3. 每位用户仅可注册一个账户，不得将账户转让、出售或出借给他人。<br />
          4. 您承诺在使用本平台时遵守所有适用的法律法规。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>三、岗位信息发布规范</h3>
        <p style={{ marginBottom: 16 }}>
          1. 发布的岗位信息应真实、合法，不得发布虚假招聘信息。<br />
          2. 不得发布含有歧视性内容（包括但不限于种族、性别、年龄、宗教歧视）的信息。<br />
          3. 不得利用本平台从事非法活动或发布违法内容。<br />
          4. 本平台有权对违规内容进行删除或屏蔽，并对违规账户采取相应措施。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>四、候选人资料</h3>
        <p style={{ marginBottom: 16 }}>
          1. 候选人自行决定是否公开个人资料及公开范围。<br />
          2. 候选人对其发布的个人信息的真实性负责。<br />
          3. 任何用户不得滥用本平台上的候选人资料，包括但不限于未经授权的商业用途、骚扰行为等。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>五、评论与互动</h3>
        <p style={{ marginBottom: 16 }}>
          1. 用户在平台发布的评论应文明、理性，不得含有侮辱、诽谤、骚扰等不当内容。<br />
          2. 不得在评论区发布广告、垃圾信息或与岗位无关的商业推广。<br />
          3. 本平台有权删除违规评论并对相关账户采取措施。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>六、知识产权</h3>
        <p style={{ marginBottom: 16 }}>
          1. 本平台的设计、功能、界面和内容（不包括用户上传内容）的知识产权归 RollSleeves 所有。<br />
          2. 用户上传的内容，用户保留其知识产权，但授予本平台在服务范围内展示和使用的权利。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>七、免责声明</h3>
        <p style={{ marginBottom: 16 }}>
          1. 本平台仅提供信息发布和交流的平台服务，不对岗位信息的真实性、准确性承担担保责任。<br />
          2. 用户通过本平台达成的任何交易或雇佣关系，由双方自行协商解决，本平台不承担连带责任。<br />
          3. 本平台不对因不可抗力、系统维护或第三方原因导致的服务中断承担责任。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>八、协议修改</h3>
        <p style={{ marginBottom: 16 }}>
          本平台有权根据需要修改本协议内容，修改后的协议将在平台上公布。继续使用本平台即视为您接受修改后的协议。
        </p>

        <h3 style={{ color: 'var(--text)', marginBottom: 12, fontSize: '1.05rem' }}>九、联系方式</h3>
        <p>
          如对本协议有任何疑问，请通过平台"联系我们"页面与我们取得联系。
        </p>
      </div>
    </div>
  );
}

export default Terms;
